import { CardContent } from "@mui/material";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import Slider from "react-slick";

interface SlideShowProps {
	customStyle?: any;
	slideContent: Array<React.ReactNode>;

	slideSettings: any;
}

export function SlideShow(props: SlideShowProps) {
	return (
		<Slider style={props.customStyle} {...props.slideSettings}>
			{props.slideContent}
		</Slider>
	);
}
